import { Pipe, PipeTransform } from "@angular/core";
import { marked, Renderer } from "marked";

@Pipe({
    name: "markdownRemover",
    standalone: false,
})
export class MarkdownRemoverPipe implements PipeTransform {
    transform(value: string | undefined | null) {
        if (!value) {
            return "";
        }

        const renderer = new Renderer();

        // override each method to return plain text
        renderer.heading = (text) => text.text + "\n";
        renderer.paragraph = (text) => text.text + "\n";
        renderer.list = (body) => body.raw + "\n";
        renderer.listitem = (text) => text.text + "\n";
        renderer.strong = ({ text }) => text;
        renderer.em = ({ text }) => text;

        return marked(value, { renderer });
    }
}
